import type { RefObject } from "react";
import { useEffect } from "react";
import { useCalendarContext } from "./context";

/**
 * After a render a move asked to focus, puts focus on the grid's tab stop.
 * Runs after every render: the request is a ref, so the check is all it costs.
 */
export const useFocusRequest = (
  gridRef: RefObject<HTMLElement | null>,
  onFocused?: (cell: HTMLElement) => void,
) => {
  const { focusRequest } = useCalendarContext();

  useEffect(() => {
    if (!focusRequest.current) return;
    const cell = gridRef.current?.querySelector<HTMLElement>('[tabindex="0"]');
    if (!cell) return;
    focusRequest.current = false;
    cell.focus({ preventScroll: true });
    onFocused?.(cell);
  });
};
